import(/* webpackMode: "eager" */ "/app/public/assets/images/logo/logo_01.svg");
import(/* webpackMode: "eager" */ "/app/src/components/ListingDetails/listing-details-1/ListingDetailsOneArea.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/viva-vibgyor/event-detail-client.tsx");
import(/* webpackMode: "eager" */ "/app/src/layouts/footers/FooterFive.tsx");
import(/* webpackMode: "eager" */ "/app/src/layouts/Wrapper.tsx")